import { PagePanelColors } from '../../types/page-panel'
import { Button, ButtonVariants, DictionaryText, InfoIcon } from '../../../MyStichtingOpenComponents/src'
import React, { ReactNode } from 'react'
import Container from './Container'

interface PagePanelProps {
    id?: string
    children: ReactNode
    color?: PagePanelColors
    hasTop?: boolean
    hasBottom?: boolean
    moreInfoText?: ReactNode
    moreInfoIcon?: ReactNode
    onClickMoreInfo?: (id?: string) => void
    className?: string
    containerClasses?: string
}

const PagePanel = React.forwardRef<HTMLDivElement, PagePanelProps>(
    (
        {
            id,
            children,
            hasTop = false,
            hasBottom = true,
            color = PagePanelColors.DEFAULT,
            moreInfoText,
            onClickMoreInfo,
            moreInfoIcon,
            className,
            containerClasses,
        },
        ref
    ) => {
        const getBackgroundColor = (): string => {
            switch (color) {
                case PagePanelColors.ACCENT:
                    return 'bg-shade-opacity-100'
                case PagePanelColors.INFO:
                    return 'bg-accent-100'
                case PagePanelColors.WARNING:
                    return 'bg-warning-100'
                default:
                    return ''
            }
        }

        const getParentStyling = (): string => {
            return Object.values({
                border: `${hasTop ? 'border-t-[1px]' : ''} ${
                    hasBottom ? 'border-b-[1px]' : ''
                } border-shade-opacity-200`,
                layout: `w-full relative`,
                spacing: 'py-8',
                colors: getBackgroundColor(),
                prop: className || '',
            }).join(' ')
        }

        return (
            <div ref={ref} className={getParentStyling()}>
                <Container size={960} className={containerClasses}>
                    {children}
                </Container>
                <div className="absolute top-1/2 -translate-y-1/2 right-8">
                    {!!onClickMoreInfo && (
                        <Button
                            variant={ButtonVariants.QUIET}
                            className="text-accent-700"
                            onClick={(event) => {
                                event.currentTarget.blur()
                                onClickMoreInfo(id)
                            }}
                            icon={moreInfoIcon || <InfoIcon />}
                        >
                            {moreInfoText || <DictionaryText textKey="STO.COMMON.MORE_INFO" />}
                        </Button>
                    )}
                </div>
            </div>
        )
    }
)

export default PagePanel
